import { useDeferredValue, useEffect, useState } from 'react';
import { useDataTableContext } from '../../../utils/DataTableContext';
import { useDataTableQuickReportsContext } from '../../../utils/DataTableQuickReportsContext';
import { usePropsForwarderContext } from '../../../plugins/impl/context/ForwarderContext';

const isTest = process.env.NODE_ENV === 'test';

export function useFetchingState() {
  const [initialized, setInitialized] = useState(!!isTest);
  const hasQuickReports = usePropsForwarderContext().isEnabled('quickReports');

  const { isFetching } = useDataTableContext();

  const { quickReports } = useDataTableQuickReportsContext();
  const isLoadingPage = useDeferredValue(!!isFetching && !initialized) ?? true;
  const isComplete = useDeferredValue(isLoadingPage && typeof quickReports !== 'undefined');

  useEffect(() => {
    if (isComplete) {
      setInitialized(true);
    }
  }, [isComplete]);

  return {
    // data
    isDataLoading: isFetching,
    // data + quick reports
    isPageLoading: !hasQuickReports ? isFetching : isLoadingPage
  };
}
